import type {Nullable} from '../types/_gat_types_reexports';
import type {
  CorePublicCouponsReserveParams,
  CoreUserCouponsApplyParams,
  CoreUserCouponsReadParams,
  CoreUserCouponsReserveParams,
} from '../types/core/methods';
import type {CouponApiModel, UsedCouponApiModel} from './types';

import {apiRequest} from '../utils/apiRequest';
import {EntityStore} from '../utils/entityStore';

class PublicCouponStore<
  T extends CouponApiModel = CouponApiModel,
> extends EntityStore<T> {
  async reserve(params: CorePublicCouponsReserveParams) {
    const result: {
      coupon: {role: CouponApiModel['role']; type: CouponApiModel['type']};
      used_coupon: {_id: string};
    } = await apiRequest<CorePublicCouponsReserveParams>({
      method: 'public.coupons.reserve',
      options: {
        withAuth: false,
      },
      params,
    });

    return {
      coupon: result.coupon,
      used_coupon: result.used_coupon,
    };
  }
}

export class CouponStore<
  T extends CouponApiModel = CouponApiModel,
> extends EntityStore<T, CoreUserCouponsReadParams> {
  public = new PublicCouponStore<T>('coupon');

  async apply(params: CoreUserCouponsApplyParams) {
    const result = await apiRequest<CoreUserCouponsApplyParams>({
      method: 'user.coupons.apply',
      params,
    });

    return result.used_coupon as Nullable<UsedCouponApiModel>;
  }

  async reserve(coupon: T) {
    const result = await apiRequest<CoreUserCouponsReserveParams>({
      method: 'user.coupons.reserve',
      params: {
        coupon_code: coupon.code,
      },
    });

    return result.used_coupon as UsedCouponApiModel;
  }
}

export const couponStore = new CouponStore('coupon', {
  fetch: 'user.coupons.read',
});
